<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="(policy.policy_number ? policy.policy_number : policy.product_name+' for '+policy.client_name)+' [Policy] - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/policies">Policies</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page" v-if="policy.policy_number">
                        {{ policy.policy_number }}
                    </li>
                    <li class="breadcrumb-item active" aria-current="page" v-else>
                        {{ policy.product_name+' for '+policy.client_name }}
                    </li>
                </ol>
            </nav>

            <h4 class="page-header">
                {{ (policy.policy_number ? policy.policy_number : policy.product_name+' for '+policy.client_name) }}
            </h4>

            <div class="mb-3" v-if="canEdit">
                <router-link :to="`/policies/edit/${policy.id}`" class="btn btn-sm btn-default"><i class="fas fa-edit"></i> Edit</router-link>
                <router-link :to="`/policies/delete/${policy.id}`" class="btn btn-sm btn-default" v-if="false"><span class="text-danger"><i class="fas fa-trash"></i> Delete</span></router-link>
            </div>

            <div class="row mb-3">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Details:</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Policy#:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    {{ policy.policy_number }}
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Product:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <router-link :to="`/policies/view/${policy.product_id}`" title="View Product">
                                        {{ policy.product_name }}
                                    </router-link>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Agent:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <router-link :to="`/agents/view/${policy.agent_id}`">{{ policy.agent_name }}</router-link>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Client:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <router-link :to="`/clients/view/${policy.client_id}`">{{ policy.client_name }}</router-link>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Last Updated At:</div>
                                <div class="col-md-8 col-12">{{ policy.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</div>
                            </div>

                            <div class="row">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Last Updated By:</div>
                                <div class="col-md-8 col-12">{{ policy.last_updated_by }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Policy Active:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <label class="badge badge-success" v-if="policy.is_active === 1">Active</label>
                                    <label class="badge badge-warning" v-else>Inactive</label>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Spouse Policy:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <label class="badge badge-success" v-if="policy.is_spouse_policy === 1">Yes</label>
                                    <label class="badge badge-warning" v-else>No</label>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Face Amount:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    {{ policy.face_amount }}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Monthly Payment:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    {{ policy.monthly_payment }}
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-lg-3 col-md-4 col-12 text-md-right">Annual Payment:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    {{ policy.annual_payment }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Notes</strong>
                        </div>
                        <div class="card-body">
                            {{ policy.notes ?? '--' }}
                        </div>
                    </div>

                    <div class="card mb-4" v-if="false">
                        <div class="card-header">
                            <strong>Files ({{ files.length }}):</strong>
                        </div>
                        <div class="card-body">
                            <files-list :files="files" />
                        </div>
                    </div>

                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Dates</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-md-4 col-12 text-md-right">Entered:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                   <span v-if="policy.entered_date">{{ policy.entered_date | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 col-12 text-md-right">Effective:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <span v-if="policy.efffective_date">{{ policy.efffective_date | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 col-12 text-md-right">Signature:</div>
                                <div class="col-md-8 col-12 input-group-sm">
                                    <span v-if="policy.signature_date">{{ policy.signature_date | moment("MM/DD/YYYY") }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-m--x mt-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === item.key" @click="curTab = item.key" v-for="item in tabs" :key="item.key">
                    <i :class="`fa fa-${item.icon}`"></i> {{ item.title }}
                </b-nav-item>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
                <b-dropdown :html="tabTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === item.key" @click="curTab = item.key" v-for="item in tabs" :key="item.key">
                        <i :class="`fa fa-${item.icon}`"></i> {{ item.title }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="pt-2">
                <div v-show="curTab === 'comments'">
                    <template v-if="$root.hasPermission('comments.create')">
                        <comments-form ref="policyCommentForm" assetType="Policy" :assetId="policy.id" @commentCreated="newComment" @commentUpdated="updateComment"></comments-form>
                        <hr/>
                    </template>

                    <comments-list ref="policyComments" assetType="Policy" :assetId="policy.id" :ajaxLoad="true" @editComment="editComment" @commentCount="((count) => { this.commentCount = count; })"></comments-list>
                </div>

                <div class="card" v-show="curTab === 'files'">
                    <div class="card-body">
                        <files-list :files="files" />
                    </div>
                </div>

                <div v-show="curTab === 'history'">
                    <div class="card">
                        <div class="card-body">
                            <history-list :record_id="policy.id" record_type="Policy" @historyCount="(count) => { this.historyCount = count; }" />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                curTab: 'comments',
                id: this.$route.params.id,
                userTimezone: this.$root.timezone,
                policy: {},
                files: [],
                commentCount: 0,
                historyCount: 0,
                downlineLevel: 0,
            }
        },

        computed: {
            tabs(){
                return [
                    {key: 'comments', title: 'Comments ('+this.commentCount+')', icon: 'comments'},
                    {key: 'files', title: 'Files ('+this.files.length+')', icon: 'clone'},
                    {key: 'history', title: 'History ('+this.historyCount+')', icon: 'clock'},
                ];
            },

            tabTitle(){
                //Loop
                for (var i = this.tabs.length - 1; i >= 0; i--)
                {
                    //Check tabl
                    if(this.tabs[i].key === this.curTab)
                    {
                        return '<i class="fa fa-'+this.tabs[i].icon+'"></i> ' + this.tabs[i].title;
                    }
                }

                //Send it
                return '';
            },

            canEdit(){
                //Check Permissions
                return this.$root.hasPermission('policies.manage');
            },
        },

        methods: {

            getPolicy(){
                //Send it
                this.$http.get('/policies/view/' + this.id)
                    .then(response => {
                        //Set the policy
                        this.policy = response.data.policy;
                        this.files = response.data.files;
                    })
                    .catch(error => {
                        console.log(errors);
                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            editComment(comment){
                //Push into the component
                this.$refs.policyCommentForm.editComment(comment);
            },

            newComment(comment){
                //Push it
                this.$refs.policyComments.addComment(comment);
            },

            updateComment(comment){
                //Update it
                this.$refs.policyComments.updateComment(comment);
            },
        },

        mounted() {
            //get the policy?
            this.getPolicy();
        }
    }
</script>
